import { Component, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { WHideEmptyModule } from '@wipo/w-angular/directives';

@Component({
    selector: 'w-edit-panel',
    templateUrl: './w-edit-panel.component.html',
    host: {
        class: 'b-edit-panel'
    },
    standalone: false
})
export class WEditPanelComponent { }
/*
@id w-edit-panel
@name w-edit-panel
@status release
*/
@NgModule({
  imports: [CommonModule, WHideEmptyModule],
  exports: [WEditPanelComponent],
  declarations: [WEditPanelComponent]
})
export class WEditPanelModule { }
